import React, { useMemo } from 'react';
import { Button, Checkbox } from 'antd';
import { FilterDropdownProps } from 'antd/es/table/interface';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './ColumnCheckboxFilter.module.scss';

type ColumnCheckboxFilterProps = Pick<
  FilterDropdownProps,
  'setSelectedKeys' | 'confirm' | 'clearFilters' | 'selectedKeys'
> & {
  options: { label: string; value: string }[];
};

export const ColumnCheckboxFilter = ({
  options,
  setSelectedKeys,
  confirm,
  clearFilters,
  selectedKeys,
}: ColumnCheckboxFilterProps): React.ReactElement => {
  const { t } = useTranslation('Timesheet');

  const checkedValues = useMemo<React.Key[]>(() => {
    return selectedKeys ?? [];
  }, [selectedKeys]);

  const optionsWithTranslatedLabels = options.map((option) => ({
    ...option,
    label: t(option.label),
  }));

  const handleChange = (values: React.Key[]): void => {
    setSelectedKeys(values as React.Key[]);
  };

  const handleReset = (): void => {
    setSelectedKeys([]);
    clearFilters?.();
    confirm();
  };

  return (
    <div className={styles.container}>
      <Checkbox.Group
        value={checkedValues}
        options={optionsWithTranslatedLabels}
        onChange={handleChange}
        className={styles.checkboxGroup}
      />
      <div className={styles.buttonContainer}>
        <Button
          onClick={handleReset}
          type="text"
          variant="outlined"
          size="small"
          className={cn(styles.btn, styles.resetButton)}
        >
          {t('resetBtn.text')}
        </Button>
        <Button type="primary" size="small" onClick={() => confirm()} className={styles.btn}>
          {t('okBtn.text')}
        </Button>
      </div>
    </div>
  );
};
